import { request } from './client';

// Public estimate (admin can call too).
export const apiEstimateShipping = ({ pincode, country, amount, itemCount, isCOD = false }) => {
  const params = new URLSearchParams();
  if (country) params.set('country', country);
  if (pincode) params.set('pincode', pincode);
  if (amount != null) params.set('amount', String(amount));
  params.set('itemCount', String(itemCount));
  if (isCOD) params.set('cod', 'true');
  return request(`/shipping/estimate?${params.toString()}`);
};

// Admin endpoints — list/create/update/delete zones + upsert rates.
export const apiAdminListShippingZones = () => request('/shipping/admin/zones');

export const apiAdminCreateShippingZone = (payload) =>
  request('/shipping/admin/zones', { method: 'POST', body: payload });

export const apiAdminUpdateShippingZone = (code, payload) =>
  request(`/shipping/admin/zones/${encodeURIComponent(code)}`, {
    method: 'PUT',
    body: payload,
  });

export const apiAdminDeleteShippingZone = (code) =>
  request(`/shipping/admin/zones/${encodeURIComponent(code)}`, { method: 'DELETE' });

export const apiAdminUpsertShippingRate = (code, payload) =>
  request(`/shipping/admin/zones/${encodeURIComponent(code)}/rate`, {
    method: 'PUT',
    body: payload,
  });

export const apiAdminTestShipping = ({ country, pincode, amount, itemCount = 1, cod }) => {
  const params = new URLSearchParams();
  if (country) params.set('country', country);
  if (pincode) params.set('pincode', pincode);
  if (amount != null) params.set('amount', String(amount));
  params.set('itemCount', String(itemCount));
  if (cod) params.set('cod', 'true');
  return request(`/shipping/admin/test?${params.toString()}`);
};
